import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import appMiddlewares from './redux/middlewares'
import reducer from './reducer'

export default (history, initialState = {}) => {
  let middleware = applyMiddleware(thunk, ...appMiddlewares, routerMiddleware(history))

  if (process.env.NODE_ENV !== 'production') {
    // configure redux-devtools-extension
    // @see https://github.com/zalmoxisus/redux-devtools-extension
    const devToolsExtension = window.devToolsExtension
    if (typeof devToolsExtension === 'function') {
      middleware = compose(middleware, devToolsExtension())
    }
  }

  const store = createStore(reducer, initialState, middleware)

  if (module.hot) {
    module.hot.accept('./reducer', () => {
      store.replaceReducer(require('./reducer').default)
    })
  }

  return store
}



// WEBPACK FOOTER //
// ./src/store.js